export const extractDomain = (baseServer) => {
  let domain = "";
  if (typeof window !== "undefined") {
    const url = window.location.origin;
    if (baseServer) {
      domain = baseServer;
    } else if (url.includes("localhost") || url.includes("test")) {
      domain = "https://recruiter.foundit.in";
    } else {
      domain = window.location.origin;
    }
  }
  return domain;
};

export const MIDDLEWARE = "/edge/dashboard/middleware";
export const API_HEADERS = {
  domain: extractDomain(),
};
export function transformQuestions(inputData, inputData2 = null) { 
    if (!inputData) return {};

    const sourceData = inputData2 ? inputData2.candidateQuestionnaire || {} : inputData;
    console.log("sourceData", sourceData);

    const transformedData = {
        "Passing Marks": inputData2 ? String(inputData2.score || "") : (inputData["Passing Marks"] || ""),
        "passPercentage":inputData2 ? String(inputData2.passPercentage || "") : (inputData["Passing Marks"] || ""),
        "Questionnaire Description": inputData["Questionnaire Description"] || "",
        "Questionnaire Name": inputData["Questionnaire Name"] || "",
        "Questions": []
    };

    let questionsArray = [];
    let longQuestion = null;

    // Collect only non-null Question keys first
    const questionKeys = Object.keys(sourceData)
        .filter(key => key.startsWith("Question") && sourceData[key] !== null && typeof sourceData[key] === "object")
        .sort((a, b) => {
            const numA = a.match(/\d+/) ? parseInt(a.match(/\d+/)[0], 10) : Infinity;
            const numB = b.match(/\d+/) ? parseInt(b.match(/\d+/)[0], 10) : Infinity;
            return numA - numB;
        });

    questionKeys.forEach(key => {
        const questionData = sourceData[key];

        const transformedQuestion = {
            "question": questionData.question,
            "points": String(questionData.marks || "0")
        };

        if ("answer" in questionData && (questionData.answer === "yes" || questionData.answer === "no")) {
            transformedQuestion["value"] = questionData.answer;
            transformedQuestion["option"] = questionData.answer === "yes" ? "A" : "B";
            transformedQuestion["type"] = "Objective";
        } else {
            transformedQuestion["value"] = questionData.answer || null;
            transformedQuestion["type"] = "Descriptive";
        }

        questionsArray.push(transformedQuestion);
    });

    // Now handle LongQuestion separately
    const longQ = sourceData["LongQuestion"] || sourceData["Long Question"];
    if (longQ && typeof longQ === "object" && longQ.question && longQ.question.trim().length > 0) {
        longQuestion = {
            "question": longQ.question,
            "points": String(longQ.marks || "0"),
            "value": longQ.answer || null,
            "type": "Descriptive"
        };
    }

    // Add IDs
    questionsArray.forEach((q, index) => q.id = index + 1);

    // Push long question at last
    if (longQuestion) {
        longQuestion.id = questionsArray.length + 1;
        questionsArray.push(longQuestion);
    }

    transformedData.Questions = questionsArray;
    
    return transformedData;
}



export function extractDesignation(current_employment) {
    if (!current_employment) return null;
    let employment = Array.isArray(current_employment) ? current_employment[0] : current_employment;

    if (!employment || !employment.designation) return null;

    return typeof employment.designation === "string"
        ? employment.designation
        : employment.designation.text || null; 
}